import { useState, useEffect, useCallback } from 'react'

import { ajax } from '@src/utils/ajax'

import { getFilterSearchParameters } from '../../AnalyticsNative'
import { RequestPayload } from '../../AnalyticsNative'

export const useData = () => {
  const [data, setData] = useState<RequestPayload | undefined>()
  const [isFetching, setIsFetching] = useState(false)

  const fetchData = useCallback(() => {
    setIsFetching(true)

    const filterParams = getFilterSearchParameters()

    ajax
      .get<RequestPayload>('/analitika_posevov_max/graphics', {
        params: filterParams
      })
      .then(response => {
        setData(response.data)
        setIsFetching(false)
      })
      .catch(() => {
        setIsFetching(false)
      })
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return {
    data,
    isFetching,
    fetchData
  }
}
